import { Routes, Route, Navigate } from 'react-router-dom'
import MainLayout from '../components/layout/MainLayout'
import Home from '../pages/home/Home'
import ProductsPage from '../pages/retailer/products/ProductsPage'
import ProductFinderPage from '../pages/product-finder/ProductFinderPage'
import RetailerShopPage from '../pages/retailer-shop/RetailerShopPage'
import SearchResultsPage from '../pages/search/SearchResultsPage'
import CategoriesProductsPage from '../pages/Categories/CategoriesProductsPage'
import RetailersPage from '../pages/retailers/RetailersPage'
import ProductBidRequestPage from '../pages/bids/ProductBidRequestPage'
import BidSuccessPage from '../pages/bids/BidSuccessPage'
import ProductBiddingListPage from '../pages/bid/ProductBiddingListPage'
import BidDetailsPage from '../pages/bids/BidDetailsPage'
import WholesalerListingPage from '../pages/Wholesaler/WholesalerListingPage'
import RetailerProductPage from '../pages/retailers/RetailerProductPage'
import CategoriesDetailsPage from '../pages/Categories/CategoriesDetailsPage'
import ProductRequestsPage from '../pages/retailer/ProductRequestsPage'
import MyProductsPage from '../pages/retailer/products/MyProductsPage'
import RetailerEditProductPage from '../pages/retailers/RetailerEditProductPage'
import UnauthorizedPage from '../pages/auth/UnauthorizedPage'
import ShopPage from '../pages/retailer-shop/ShopPage'
import LoginPage from '../pages/auth/LoginPage'
import SignupStepper from '../pages/auth/SignupStepper'
import { useAuth } from '../contexts/AuthContext'
import PrivacyPolicyPage from '../pages/policy/PrivacyPolicyPage'
import ReturnPolicyPage from '../pages/policy/ReturnPolicyPage'
import TermsAndConditionsPage from '../pages/policy/TermsAndConditionsPage'
import PricingPage from '../pages/pricing/PricingPage'
import CustomerFavoriteRetailersPage from '../pages/favorites/CustomerFavoriteRetailersPage'
import WholesellerProductDetailsPage from '../pages/Wholesaler/WholesellerProductDetailsPage'
import { ErrorBoundary } from '@sentry/react'
import ServerErrorPage from '../pages/auth/ServErrorPage'
import PageNotFound from '../pages/auth/PageNotFound'

import AdminCustomerManagementPage from '../pages/admin/CustomerManagementPage'
import CustomerDetailsPage from '../pages/admin/CustomerDetailsPage'
import ViewProductsPage from '../pages/retailer/products/ViewProductsPage.jsx'
import AdminSubscriptionsPage from '../pages/admin/SubscriptionsPage'
import AdminPromotionsPage from '../pages/admin/PromotionsPage'
import AdminSupportPage from '../pages/admin/SupportPage'
import AdminReportsPage from '../pages/admin/ReportsPage'

import RetailerProductFinderResponsePage from '../pages/retailer/RetailerProductFinderresponsePage'

import MessageInboxPage from '../pages/messages/MessageInbox.jsx'
import ConversationPage from '../pages/messages/ConversationPage.jsx'
import ShopHomePage from '../pages/retailer/products/ShopHomePage.jsx'
import DisplayWholesellers from '../pages/admin/DisplayWholesellers.jsx'
import WholesellerDetailsPage from '../pages/admin/WholesellerDetailsPage.jsx'
import DisplayRetailers from '../pages/admin/DisplayRetailers.jsx'
import RetailerDetailsPage from '../pages/admin/RetailerDetailsPage.jsx'
import USER_TYPE from '../constants/userType.js'
import AdminLayout from '../components/layout/AdminLayout.jsx'
import AdminWholesellersPage from '../pages/admin/AdminWholesellersPage.jsx'
import { PRODUCT_FINDER_TABS } from '../constants/productFinder.js'
import ShopEditPage from '../pages/retailer-shop/ShopEditPage.jsx'
import SupportTicketView from '../pages/admin/SupportTicketView'
import SubscriptionsPage from '../pages/subscription/SubscriptionsPage'
import SupportPage from '../pages/support/SupportPage'
import SupportTicketMessage from '../pages/support/SupportTicketMessage'
import PromotionDetailsPage from '../pages/admin/PromotionDetailsPage.jsx'
import ReportsTicketDetailsPage from '../pages/admin/ReportsTicketDetailsPage'
import ForgotPasswordInitiate from '../pages/auth/ForgotPasswordInitiate'
import ForgotPasswordOtpVerification from '../pages/auth/ForgotPasswordOtpVerification'
import ForgotPasswordReset from '../pages/auth/ForgotPasswordReset'
import ShopVerificationPage from '../pages/retailer-shop/ShopVerificationPage.jsx'
import ShopVerifications from '../pages/admin/ShopVerificationsPage.jsx'
import ShopVerificationDetails from '../pages/admin/ShopVerificationDetailsPage.jsx'

export const AppRoutes = () => {
  const { isAuthenticated, currentUser } = useAuth()

  const getSharedRoutes = () => {
    return [
      {
        path: '/privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: '/return-policy',
        element: <ReturnPolicyPage />,
      },
      {
        path: '/terms',
        element: <TermsAndConditionsPage />,
      },
      {
        path: '/pricing',
        element: <PricingPage />,
      },
      {
        path: '/unauthorized',
        element: <UnauthorizedPage />,
        hideMainLayout: true,
      },
      {
        path: '/server-error',
        element: <ServerErrorPage />,
        hideMainLayout: true,
      },
      {
        path: '/products',
        element: <ProductsPage />,
      },
      {
        path: '/search',
        element: <SearchResultsPage />,
      },
      {
        path: '/categories',
        element: <CategoriesProductsPage />,
      },
      {
        path: '/categories/:categorySlug',
        element: <CategoriesDetailsPage />,
      },
      {
        path: '/retailers',
        element: <RetailersPage />,
      },
      {
        path: '/wholesellers',
        element: <WholesalerListingPage />,
      },
      {
        path: '/retailers/:shopSlug/products',
        element: <RetailerShopPage isRetailer={true} />,
      },
      {
        path: '/wholesellers/:shopSlug/products',
        element: <RetailerShopPage isRetailer={false} />,
      },
      {
        path: '/products/:productSlug',
        element: <ProductBidRequestPage />,
      },
      {
        path: '/retailers/:shopSlug/products/:productSlug',
        element: <ProductBidRequestPage />,
      },
      {
        path: '/wholesellers/:shopSlug/products/:productSlug/request-quote',
        element: <WholesellerProductDetailsPage />,
      },
      {
        path: '/support',
        element: <SupportPage />,
      },
      {
        path: '/support-tickets/:ticketId/message',
        element: <SupportTicketMessage />,
        hideMainLayout: true,
      },
      {
        path: '/subscription',
        element: <SubscriptionsPage />,
      },
    ]
  }

  const getGuestRoutes = () => {
    if (currentUser) {
      return []
    }

    return [
      {
        path: '/',
        element: <Home />,
      },
    ]
  }

  const getCustomerRoutes = () => {
    if (currentUser?.userType !== USER_TYPE.customer) return []
    return [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/messages',
        element: <MessageInboxPage />,
      },
      {
        path: '/product-finder',
        element: <ProductFinderPage activeTab={PRODUCT_FINDER_TABS.FIND} />,
      },
      {
        path: '/product-finder/responses',
        element: <ProductFinderPage activeTab={PRODUCT_FINDER_TABS.RESPONSES} />,
      },
      {
        path: '/bids/success',
        element: <BidSuccessPage />,
      },
      {
        path: '/bids',
        element: <ProductBiddingListPage />,
      },
      {
        path: '/bids/:bidId',
        element: <BidDetailsPage />,
      },

      {
        path: '/messages/:conversationId',
        element: <ConversationPage />,
        hideMainLayout: true,
      },

      {
        path: '/favorites',
        element: <CustomerFavoriteRetailersPage />,
      },
    ]
  }

  const getRetailerRoutes = () => {
    if (currentUser?.userType !== USER_TYPE.retailer) return []

    return [
      {
        path: '/',
        element: <ShopHomePage />,
      },
      {
        path: '/shop-verification',
        element: <ShopVerificationPage />,
      },
      {
        path: '/messages',
        element: <MessageInboxPage />,
      },
      {
        path: '/messages/:conversationId',
        element: <ConversationPage />,
        hideMainLayout: true,
      },
      {
        path: '/retailer/products/requests',
        element: <ProductRequestsPage />,
      },
      {
        path: '/retailer/products/:productSlug/edit',
        element: <RetailerEditProductPage />,
      },
      {
        path: '/my-shop',
        element: <ShopPage />,
      },
      {
        path: '/my-products',
        element: <MyProductsPage />,
      },
      {
        path: '/retailer/products/requests/:id',
        element: <RetailerProductFinderResponsePage />,
      },
      {
        path: '/retailer/add-product',
        element: <RetailerProductPage />,
      },
      {
        path: '/retailer/product-requests',
        element: <ProductRequestsPage />,
      },
      {
        path: '/retailer/my-products',
        element: <MyProductsPage />,
      },

      {
        path: '/retailer/products/:productSlug',
        element: <ViewProductsPage />,
      },
      {
        path: '/my-shop/edit',
        element: <ShopEditPage />,
      },
    ]
  }

  const getWholesellerRoutes = () => {
    if (currentUser?.userType !== USER_TYPE.wholeseller) return []

    return [
      {
        path: '/',
        element: <ShopHomePage />,
      },
      {
        path: '/messages',
        element: <MessageInboxPage />,
      },
      {
        path: '/messages/:conversationId',
        element: <ConversationPage />,
        hideMainLayout: true,
      },
      {
        path: '/wholesellers',
        element: <WholesalerListingPage />,
      },
      {
        path: '/wholeseller/add-product',
        element: <RetailerProductPage />,
      },
      {
        path: '/wholeseller/product-requests',
        element: <ProductRequestsPage />,
      },
      {
        path: '/wholeseller/edit-product/:productSlug',
        element: <RetailerEditProductPage />,
      },
      {
        path: '/my-shop',
        element: <ShopPage />,
      },
      {
        path: '/shop-verification',
        element: <ShopVerificationPage />,
      },
      {
        path: '/my-products',
        element: <MyProductsPage />,
      },
      {
        path: '/wholeseller/view-product-page',
        element: <ViewProductsPage />,
      },
      {
        path: '/wholeseller/products/:productSlug',
        element: <ViewProductsPage />,
      },
      {
        path: '/wholeseller/products/:productSlug/edit',
        element: <RetailerEditProductPage />,
      },
      {
        path: '/my-shop/edit',
        element: <ShopEditPage />,
      },

      {
        path: '/wholeseller/products/:productSlug',
        element: <ViewProductsPage />,
      },
    ]
  }

  const getAuthRoutes = () => {
    return [
      {
        path: '/login',
        element: <LoginPage />,
        hideMainLayout: true,
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordInitiate />,
        hideMainLayout: true,
      },
      {
        path: '/forgot-password/verify-otp',
        element: <ForgotPasswordOtpVerification />,
        hideMainLayout: true,
      },
      {
        path: '/forgot-password/reset',
        element: <ForgotPasswordReset />,
        hideMainLayout: true,
      },
      {
        path: '/signup',
        element: isAuthenticated() ? (
          <Navigate to="/" replace />
        ) : (
          <SignupStepper userType={USER_TYPE.customer} />
        ),
        hideMainLayout: true,
      },
      {
        path: '/signup/retailer',
        element: <SignupStepper userType={USER_TYPE.retailer} />,
        hideMainLayout: true,
      },
      {
        path: '/signup/wholesaler',
        element: <SignupStepper userType={USER_TYPE.wholeseller} />,
        hideMainLayout: true,
      },
    ]
  }

  const getAdminRoutes = () => {
    if (currentUser?.userType !== USER_TYPE.admin) return []

    return [
      {
        path: '/',
        element: <Navigate to="/admin/customers" replace />,
      },
      {
        path: '/admin/customers',
        element: <AdminCustomerManagementPage />,
      },
      {
        path: '/admin/customers/:id',
        element: <CustomerDetailsPage />,
      },
      {
        path: '/admin/wholesellers',
        element: <DisplayWholesellers />,
      },

      {
        path: '/admin/retailers',
        element: <DisplayRetailers />,
      },
      {
        path: '/admin/retailers/:shopSlug',
        element: <RetailerDetailsPage />,
      },
      {
        path: '/admin/shop-verifications',
        element: <ShopVerifications />,
      },
      {
        path: '/admin/shop-verifications/:id',
        element: <ShopVerificationDetails />,
      },
      {
        path: '/admin/subscriptions',
        element: <AdminSubscriptionsPage />,
      },
      {
        path: '/admin/wholesellers',
        element: <AdminWholesellersPage />,
      },
      {
        path: '/admin/promotions',
        element: <AdminPromotionsPage />,
      },
      {
        path: '/admin/support',
        element: <AdminSupportPage />,
      },
      {
        path: '/admin/support/:ticketId',
        element: <SupportTicketView />,
      },

      {
        path: '/admin/moderation',
        element: <AdminReportsPage />,
      },
      {
        path: '/admin/moderation/:id',
        element: <ReportsTicketDetailsPage />,
      },
      {
        path: '/admin/wholesellers/:shopSlug',
        element: <WholesellerDetailsPage />,
      },
      {
        path: '/admin/promotions/:promotionId',
        element: <PromotionDetailsPage />,
      },
    ]
  }

  return (
    <ErrorBoundary>
      <Routes>
        {[
          ...getGuestRoutes(),
          ...getCustomerRoutes(),
          ...getRetailerRoutes(),
          ...getWholesellerRoutes(),
          {
            path: '*',
            element: <PageNotFound />,
          },
        ].map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              route.hideMainLayout ? route.element : <MainLayout>{route.element}</MainLayout>
            }
          />
        ))}

        {[...getSharedRoutes(), ...getAuthRoutes()].map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              route?.hideMainLayout ? route.element : <MainLayout>{route.element}</MainLayout>
            }
          />
        ))}
        {getAdminRoutes().map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<AdminLayout>{route.element}</AdminLayout>}
          />
        ))}
      </Routes>
    </ErrorBoundary>
  )
}
